import axios from "axios";

export default axios.create({
  baseURL: "https://35gqvqnoo8.execute-api.us-east-1.amazonaws.com/Test/"
});
